/* Adds Page-owned records without replacing existing guide controls or forms. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.__bnGuideRecordsMounted || !window.BionoboGuideCatalog) return;
    root.__bnGuideRecordsMounted = true;
    var controller = window.BionoboGuideCatalog.mount(root, { sectionId: root.getAttribute('data-section-id') });
    function sync() {
      var snapshot = controller.snapshot();
      var status = root.querySelector('[data-bn-guide-record-status]');
      var pagination = root.querySelector('[data-bn-guide-record-pagination]');
      if (status) status.hidden = snapshot.complete && !snapshot.selection;
      if (pagination) pagination.hidden = snapshot.complete;
      root.dispatchEvent(new CustomEvent('bn:guide-records-updated', { detail: { selection: snapshot.selection } }));
    }
    var observer = new MutationObserver(sync);
    observer.observe(root, { attributes: true, attributeFilter: ['data-bn-guide-state'] });
    var cards = root.querySelector('[data-bn-guide-cards]');
    if (cards) observer.observe(cards, { childList: true });
    controller.ready.then(sync);
    function unload(event) {
      if (!event.target || !event.target.contains(root)) return;
      observer.disconnect(); controller.destroy();
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
  }
  function all() { document.querySelectorAll('[data-bn-guide-catalog]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all, { once: true });
  else all();
  document.addEventListener('shopify:section:load', all);
})();
